"use client";

/**
 * Web Vitals Reporter
 * Reports Core Web Vitals to the analytics layer. Renders nothing.
 */

import { initWebVitals } from "@/lib/WebVitals";
import { useEffect } from "react";

export default function WebVitalsReporter() {
  useEffect(() => {
    initWebVitals();
  }, []);

  return null;
}
